import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import FundedAccountsLeaderboard from '../../components/funded-accounts-leaderboard';
import { ADMIN } from '../../utilities/functions';

import './styles.scss';

const PAGE_SIZE = 10;

export default function FundedAccountsLeaderboardPage() {
    const [page, setPage] = useState(1);
    const [sortBy, setSortBy] = useState('paidDate');
    const [sortOrder, setSortOrder] = useState('desc');
    const [period, setPeriod] = useState('all_time');

    const {
        data: leaderboardData,
        isLoading,
        isFetching,
        error
    } = useQuery(
        ['public-funded-accounts-leaderboard', page, PAGE_SIZE, sortBy, sortOrder, period],
        () =>
            ADMIN.fetchPaidFundedAccountsLeaderboard({
                page,
                pageSize: PAGE_SIZE,
                sortBy,
                sortOrder,
                period
            }),
        { keepPreviousData: true }
    );

    const handleTableChange = (pagination, _filters, sorter, extra) => {
        const nextPage = pagination?.current || 1;
        const normalizedSorter = Array.isArray(sorter) ? sorter[0] : sorter;
        const sorterField = normalizedSorter?.field || normalizedSorter?.columnKey;

        if (extra?.action === 'sort') {
            if (sorterField === 'pnl' && normalizedSorter.order) {
                setSortBy('pnl');
                setSortOrder(normalizedSorter.order === 'ascend' ? 'asc' : 'desc');
            } else if (sorterField === 'closedPaidAt' && normalizedSorter.order) {
                setSortBy('paidDate');
                setSortOrder(normalizedSorter.order === 'ascend' ? 'asc' : 'desc');
            } else {
                setSortBy('paidDate');
                setSortOrder('desc');
            }
            setPage(1);
            return;
        }

        setPage(nextPage);
    };

    const handlePeriodChange = (value) => {
        setPeriod(value);
    };

    const fixedStats = leaderboardData?.topLeaderboard?.stats || null;

    return (
        <div className="leaderboard-page">
            <FundedAccountsLeaderboard
                rows={leaderboardData?.rows || []}
                topLeaderboard={leaderboardData?.topLeaderboard}
                fixedStats={fixedStats}
                period={period}
                onPeriodChange={handlePeriodChange}
                isLoading={isLoading || isFetching}
                error={error}
                page={leaderboardData?.page || page}
                pageSize={leaderboardData?.pageSize || PAGE_SIZE}
                total={leaderboardData?.total || 0}
                sortBy={leaderboardData?.sortBy || sortBy}
                sortOrder={leaderboardData?.sortOrder || sortOrder}
                onTableChange={handleTableChange}
            />
        </div>
    );
}
